
<div class="card grid no-ml-mr" *ngIf="!activeItem?.disabled && !setupLoading">
    <div class="mt-2 ml-2 col-12">
        <app-esa-setup-inputs [selectedProject]="selectedProject" [canMakeEdits]="isProjectOwnershipValid && !isProjectRunning" [currentUserName]="currentUserName" (isSetupValidEvent)="validateSetupInfoInProject($event)"></app-esa-setup-inputs>
    </div>
    <div class="mt-5 ml-2 col-12 pr-3 mr-2">
        <app-esa-setup-models-to-be-run [selectedProject]="selectedProject" [canMakeEdits]="isProjectOwnershipValid && !isProjectRunning" [projectPk]="selectedProject ? selectedProject.projectPk : 0" (areSetupModelsValidEvent)="validateSetupModelInProject($event)"></app-esa-setup-models-to-be-run>
    </div>
</div>

<app-loading class="flex align-items-center justify-content-center" *ngIf="setupLoading"></app-loading>
